import type { MobileContentFrameWindow } from './types';

declare let window: MobileContentFrameWindow;

export const removeTruncatedArticleMessage = () => {
  const container = document.querySelector('.truncated-paywall-article-message-container');
  if (!container) {
    return;
  }
  container.classList.add('hidden');
};

const instructionsIOS = (articleUrl: string) => `
  <p>
    However, if you <a href="${articleUrl}">open this article in Safari</a>, log into the site, and share it to Reader from there, we'll be able to access the full article text for you.
  </p>
  <p>
    (You can also save the full article content to Reader using our desktop browser extension.)
  </p>
`;

const instructionsAndroid = () => `
  <p>
    However, on any <b>desktop device</b>, you can use our browser extension to save the article full content (<a href="https://docs.readwise.io/reader/docs/faqs/adding-new-content#how-do-i-install-the-reader-chrome-extension">read more here</a>).
  </p>
`;

export const addTruncatedArticleMessage = (articleUrl: string) => {
  const container = document.querySelector('.truncated-paywall-article-message-container');
  if (!container) {
    return;
  }

  container.classList.remove('hidden');

  container.innerHTML = `
      <p>
        You saved this paywalled article to Reader using only the URL.
        Unfortunately, the paywall prevents us from accessing the full content.
      </p>
      ${window.osType === 'ios' ? instructionsIOS(articleUrl) : instructionsAndroid()}
  `;
};
